{
    "importCargoHeaders": [
        {
            "displayLabel": "IGM Item No",
            "fieldName": "igmItemNo"
        },
        {
            "displayLabel": "Vessel Name",
            "fieldName": "vesselName"
        },
        {
            "displayLabel": "Account Holder",
            "fieldName": "accountHolderName"
        },
        {
            "displayLabel": "MBL No",
            "fieldName": "blNo"
        },
        {
            "displayLabel": "BOE No",
            "fieldName": "boeNo"
        },
        {
            "displayLabel": "CHA",
            "fieldName": "chaName"
        },
        {
            "displayLabel": "Commodity",
            "fieldName": "commodityValue"
        },
        {
            "displayLabel": "NOP",
            "fieldName": "numberOfPackages"
        },
        {
            "displayLabel": "Gross Weight",
            "fieldName": "grossWeight"
        }
    ]
}